import { useQuery } from 'react-query';
import { getSubjectLines } from './getSubjectLines';

export const useGetSubjectLines = ({ siteId }: { siteId: string }) => {
  return useQuery(['subjectLines'], () => getSubjectLines({ siteId }));
};
